import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Box from 'ui-box';
import { Row, Col, Typography, Divider } from 'antd';
import HeaderBack from '../../../components/mobile/HeaderBack';
import { ReactComponent as VideoSvg } from '../../../assets/icons/knowledge-bank/video.svg';
import { ReactComponent as ReadSvg } from '../../../assets/icons/knowledge-bank/read.svg';
import { ReactComponent as InfographicSvg } from '../../../assets/icons/knowledge-bank/infographic.svg';
import { ReactComponent as AudioSvg } from '../../../assets/icons/knowledge-bank/audio.svg';

const { Title } = Typography;
const data = [
  {name: 'Video', icon: <VideoSvg />, url: '/knowledge-bank/detail/video'},
  {name: 'Audio', icon: <AudioSvg />, url: '/knowledge-bank/detail/audio'},
  {name: 'Infographics', icon: <InfographicSvg />, url: '/knowledge-bank/detail/infographic'},
  {name: 'Read', icon: <ReadSvg />, url: '/knowledge-bank/detail/read'},
];

const styles = {
  itemTitle: {
    fontSize: 14,
    lineHeight: '17px',
    textAlign: 'center',
    fontWeight: '400',
    color: '#404047',
    marginBottom: 0
  },
  box: {
    background: '#FFFFFF',
    border: '1px solid #F4F4F4',
    borderRadius: 5,
    marginRight: 12,
    marginBottom: 12,
    minHeight: 150
  },
  circle: {
    width: 100,
    height: 100,
    backgroundColor: '#E7E7E7',
    borderRadius: '50%',
    margin: '0 auto',
    marginBottom: 15
  }
};

function MobileKnowledgeBankDetailScreen() {
  const { t } = useTranslation(['knowledge-bank', 'common']);
  const history = useHistory();

  const onBack = () => {
    history.push('/knowledge-bank')
  }

  const renderAvatar = (item) => {
    return (
      <Col xs={12}>
        <Box paddingY={12} paddingX={18} style={styles.box} onClick={() => history.push(item.url)}>
          {
            item.icon !== null
            ? (
              <Box textAlign="center" style={{ marginBottom: 15 }}>
                {item.icon}
              </Box>
            )
            : (
              <Box style={styles.circle} />
            )
          }
          <Title level={4} style={styles.itemTitle}>
            {item.name}
          </Title>
        </Box>
      </Col>
    )
  }

  return (
    <>
      <HeaderBack
        onBack={onBack}
        text={t('knowledge-bank:covid.backTitle')}
        title={t('knowledge-bank:covid.title')}
        subtitle={t('knowledge-bank:covid.subtitle')}
      />
      <Box marginBottom={35}>
        <Divider />
      </Box>
      <Row>
        {data.map((item) => renderAvatar(item))}
      </Row>
    </>
  );
}

export default MobileKnowledgeBankDetailScreen;
